import React from 'react';
import { Link } from 'react-router-dom';
import { mockData } from '../mock';
import { Card, CardContent } from '../components/ui/card';
import ImageCarousel from '../components/ui/image-carousel';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}

      {/* Featured Brands Section */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {mockData.featuredBrands.map((brand, index) => (
            <Card 
              key={brand.id} 
              className="group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden"
            >
              <div className="relative h-[480px] overflow-hidden">
                <ImageCarousel
                  images={brand.carouselImages}
                  alt={brand.title}
                  className="w-full h-full group-hover:scale-105 transition-transform duration-500"
                  interval={4000}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                <div className="absolute bottom-4 left-4 right-4 text-white text-center">
                  <p className="text-[16px] font-medium text-white uppercase tracking-wide mb-1">
                    {brand.name}
                  </p>
                  <h3 className="text-xl font-bold leading-tight">
                    {brand.title}
                  </h3>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>

      {/* Secondary Features Grid */}
      <div className="bg-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {mockData.featuredBrands.map((brand, index) => {
              // Map to different bottom images
              const bottomImageMap = {
                'blue-tokai': '/images/home_bottom_blue_tokai.png',
                'furn-beano': '/images/home_bottom_furn_beano.png',
                'biryani-by-kilo': '/images/home_bottom_bbk.png',
                'mr-brown': '/images/home_bottom_brown.jpg'
              };
              
              return (
                <div key={`secondary-${brand.id}`} className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300">
                  <div className="h-48 overflow-hidden">
                    <img
                      src={bottomImageMap[brand.id] || brand.image}
                      alt={brand.title}
                      className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <div className="text-center mb-4">
                      <p className="text-xs font-semibold text-red-600 uppercase tracking-wider mb-1">
                        {brand.name}
                      </p>
                      <h4 className="text-[32px] font-bold leading-tight" style={{color: '#73030D'}}>
                        {brand.title}
                      </h4>
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed mb-4 text-center">
                      {brand.description.length > 150 
                        ? `${brand.description.substring(0, 150)}...` 
                        : brand.description
                      }
                    </p>
                    <div className="text-center">
                      <Link 
                        to="/brands"
                        className="inline-block bg-red-600 text-white px-4 py-2 text-xs font-semibold uppercase tracking-wide rounded hover:bg-red-700 transition-colors duration-200"
                      >
                        READ MORE
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;